import TCEventsView from './components/Blocks/TCEvents/View';
import TCEventsEdit from './components/Blocks/TCEvents/Edit';
import TCEventsSchema from './components/Blocks/TCEvents/Schema';

import CAMEventsView from './components/Blocks/CAMEvents/View';
import CAMEventsEdit from './components/Blocks/CAMEvents/Edit';
import CAMEventsSchema from './components/Blocks/CAMEvents/Schema';

import eventsIcon from '@plone/volto/icons/calendar.svg';

import PersonView from './components/Views/PersonView';

const applyConfig = (config) => {
  config.settings.isMultilingual = true;
  config.settings.supportedLanguages = ['en', 'hi'];
  config.settings.defaultLanguage = 'en';

  config.settings.siteTitleFormat = {
    includeSiteTitle: true,
    separator: '-',
  };

  // Basic nav related settings
  config.settings = {
    ...config.settings,
    navDepth: 3,
    openExternalLinkInNewTab: true,
    hasWorkingCopySupport: true,
    matomoSiteId: '2',
    matomoUrlBase: 'https://stats.tifrbng.res.in/',
  };

  //Remove footer set by VLT
  config.unRegisterSlotComponent('postFooter', 'Colophon', 0);

  //volto-slider-block auto play
  config.blocks.blocksConfig.slider.enableAutoPlay = true;

  //volto-carousel-block auto Loop enable
  config.blocks.blocksConfig.carousel = {
    ...config.blocks.blocksConfig.carousel,
    allowLoop: true,
  };

  //TIFR CAM Events Block
  config.blocks.blocksConfig.tcEvents = {
    id: 'tcEvents',
    title: 'TC Events',
    icon: eventsIcon,
    group: 'common',
    view: TCEventsView,
    edit: TCEventsEdit,
    schema: TCEventsSchema,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
    blockHasOwnFocusManagement: false,
  };
  
  // TIFR CAM Events Block  (Updated)
  config.blocks.blocksConfig.camEvents = {
  id: 'camEvents',
  title: 'CAM Events',
  icon: eventsIcon,
  group: 'common',
  view: CAMEventsView,
  edit: CAMEventsEdit,
  schema: CAMEventsSchema,
  restricted : false,
  mostUsed: false,
  sidebarTab: 1,
  blockHasOwnFocusManagement: false,
  };

  config.views = {
    ...config.views,
    contentTypesViews: {
      ...config.views.contentTypesViews,
      person: PersonView,
    },
  };

  return config;
};

export default applyConfig;
